module.exports = __webpack_public_path__ + "models/scene5adults.ec5308b.txt";